module.exports = __webpack_public_path__ + "img/plan-red.95268653.svg";